import { MediasLogo } from "~/features/navigation/components/TopBar/MediasLogo";
import { REGISTER_PAGE } from "~/utils/url/staticUrls";

import { Box, Button, styled } from "~/common/mui";
import { useTranslation } from "react-i18next";
import PersonIcon from "@mui/icons-material/Person";

const Root = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2),
  backgroundColor: theme.palette.surface.main,
  border: "none",
  justifyContent: "center",
  gap: theme.spacing(4),
  [theme.breakpoints.between("desktop-m", "desktop-l")]: {
    gap: theme.spacing(3),
  },
  [theme.breakpoints.up("desktop-m")]: {
    justifyContent: "flex-start",
  },
}));

const Logo = styled(MediasLogo)({
  flex: "none",
  height: 22,
  width: 149,
});

const Divider = styled("div")(({ theme }) => ({
  height: "100%",
  width: 1,
  background: theme.palette.divider,
}));

const Text = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  maxWidth: 350,
}));
export const LinearTeaser = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <Root className={className}>
      <Logo variant={"plus"} />
      <Divider />
      <Text>{t("page.linear.summary.register.message")}</Text>
      <Button
        className={"scha__lc-summary__lc-register-teaser-button"}
        href={REGISTER_PAGE}
        startIcon={<PersonIcon sx={{ fontSize: 20 }} />}
      >
        {t("page.registerFree.register")}
      </Button>
    </Root>
  );
};
